import { AddressSchema } from "@redotech/account-common/address-schema";
import { addressTypeSchema } from "@redotech/redo-model/address-collection";
import * as z from "zod";

export const getAddresses = {
  name: "getAddresses" as const,
  input: z.object({ type: addressTypeSchema.optional() }),
  output: z.object({ addresses: z.array(AddressSchema) }),
};
